export default "__VITE_ASSET__Dwc5av$T__"